import headshot from "@/assets/ruby-steinbrecher.webp";
import type { LorsCopy } from "./translations";

const LorsAbout = ({ copy }: { copy: LorsCopy }) => (
  <section className="py-20 bg-background">
    <div className="container max-w-5xl mx-auto px-6">
      <div className="flex flex-col md:flex-row items-start gap-10">
        <div className="flex-shrink-0 mx-auto md:mx-0">
          <img
            src={headshot}
            alt="Ruby Steinbrecher"
            width={640}
            height={960}
            loading="lazy"
            decoding="async"
            className="w-64 h-96 md:w-80 md:h-[28rem] rounded-2xl object-cover object-top shadow-lg"
          />
        </div>
        <div>
          <p
            className="lors-eyebrow uppercase tracking-widest text-xs mb-2 font-semibold"
            style={{ color: "hsl(210 24% 35%)" }}
          >
            {copy.aboutRole}
          </p>
          <h2 className="lors-headline text-3xl md:text-4xl mb-6">{copy.aboutTitle}</h2>
          {copy.aboutBody.map((para, i) => (
            <p key={i} className="text-base md:text-lg leading-8 mb-4 last:mb-0">
              {para}
            </p>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default LorsAbout;
